module.exports = __webpack_public_path__ + "img/mobcardasmnticon.0daec311.svg";